/*
Buffing Products
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Buffing Products'
const id = '9uaXgljPi2lqVk1Vm5lq'

export default {
  name,
  id,
  filters,
  headers,
  form
}
